import { memo } from 'react';
import { useLocation } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Text } from '@library';
import { buildBreadcrumbs } from '../../util/categories';
import type Category from '../../types/category';
import CustomLink from '../CustomLink';
import withErrorBoundary from '../errors/withErrorBoundary';
import CurrentStoreLink from './CurrentStoreLink';
import styles from './BreadcrumbsViews.module.scss';
import Breadcrumbs from './Breadcrumbs';

const BreadcrumbsViews = withErrorBoundary(
    ({
        rootLinks = [],
        category,
    }: {
        rootLinks?: {
            text?: string;
            messageId?: string;
            to?: string;
        }[];
        category?: Category;
    }) => {
        const { search } = useLocation();

        return (
            <div className={styles.breadcrumbViews}>
                <Breadcrumbs separator="›">
                    <CurrentStoreLink
                        className={styles.breadcrumbLink}
                        key="home"
                        to="/"
                    >
                        <Text tertiary uppercase>
                            <FormattedMessage id="home page" />
                        </Text>
                    </CurrentStoreLink>

                    {rootLinks.map(({ messageId, to, text }) => {
                        const label = messageId ? (
                            <FormattedMessage id={messageId} />
                        ) : (
                            text
                        );
                        if (to) {
                            return (
                                <CurrentStoreLink
                                    className={styles.breadcrumbLink}
                                    key={messageId || text}
                                    to={to}
                                >
                                    <Text tertiary uppercase>
                                        {label}
                                    </Text>
                                </CurrentStoreLink>
                            );
                        }

                        return (
                            <div
                                className={styles.breadcrumbLink}
                                key={messageId || text}
                            >
                                <Text tertiary uppercase>
                                    {label}
                                </Text>
                            </div>
                        );
                    })}
                    {category &&
                        buildBreadcrumbs(category).map(({ name, id }) => {
                            return (
                                <CustomLink
                                    className={styles.breadcrumbLink}
                                    key={name}
                                    to={`../categories/${id}${search}`}
                                >
                                    <Text tertiary uppercase>
                                        {name}
                                    </Text>
                                </CustomLink>
                            );
                        })}
                </Breadcrumbs>
            </div>
        );
    }
);

/**
 * @deprecated
 */
export default memo(BreadcrumbsViews);
